import { render, staticRenderFns } from "./TctReagent.vue?vue&type=template&id=74c9094d&"
import script from "./TctReagent.vue?vue&type=script&lang=js&"
export * from "./TctReagent.vue?vue&type=script&lang=js&"
import style0 from "./TctReagent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports